import { Button, Loader } from "@braintrust/braintrust-ui-components";
import { ArrowRightIcon } from "@braintrust/braintrust-ui-components/Icons";

export const SignUpConfirmButton = ({
  onClick,
  isLoading,
}: {
  onClick?: VoidFunction;
  isLoading?: boolean;
}) => {
  return (
    <Button
      onClick={onClick}
      variant="dark-violet"
      size="medium"
      shape="squared"
      fullWidth
      sx={{
        boxShadow: "0px 4px 12px 0px #5D197440 !important",
        svg: { color: "var(--white)" },
      }}
      endIcon={isLoading ? <Loader size={20} /> : <ArrowRightIcon />}
      disabledType="no-change"
      type="submit"
    >
      Create my account
    </Button>
  );
};
